import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const PencilSquareIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/pencil-square"><path id="Icon" d="M18 14.0001V18.7501C18 19.9928 16.9926 21.0001 15.75 21.0001H5.25C4.00736 21.0001 3 19.9928 3 18.7501V8.25014C3 7.0075 4.00736 6.00014 5.25 6.00014H10M19.7176 7.11178L11.111 15.7184L6.86835 17.1326L8.28257 12.89L16.8892 4.28335L19.0105 2.16203C19.401 1.77151 20.0342 1.77151 20.4247 2.16203L21.8389 3.57625C22.2294 3.96677 22.2294 4.59994 21.8389 4.99046L19.7176 7.11178ZM16.8892 4.28335L19.7176 7.11178" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PencilSquareIcon;